import { Injectable, inject } from '@angular/core';
import { Api } from '../api/api.service';
import { ConfirmService } from '../confirm/confirm.service';
import { Snackbar } from '../snackbar/snackbar.service';
import { ClientDiaryDataService } from './client-diary-data.service';

@Injectable({ providedIn: 'root' })
export class DiaryCompleteService {
  private api = inject(Api);
  private confirm = inject(ConfirmService);
  private snackbar = inject(Snackbar);
  private clientDiaryData = inject(ClientDiaryDataService);

  confirmAndMarkComplete(
    diaryIds: number[],
    onSuccess?: () => void | Promise<void>,
  ): void {
    const count = diaryIds.length;
    if (count === 0) {
      return;
    }

    const noun = count === 1 ? 'diary' : 'diaries';
    this.confirm.show({
      label: 'Mark diary complete',
      message: `Are you sure you want to mark ${count} ${noun} complete?`,
      width: '35rem',
      yesLabel: 'Yes',
      noLabel: 'No',
      confirm: async () => {
        await this.api.clientDiary.markCompleteBatch(diaryIds);
        this.clientDiaryData.notifyChanged();
        const message =
          count === 1 ? 'Diary completed' : 'Diaries completed';
        this.snackbar.show(message, 'Success', 'fa-light fa-thumbs-up', 4000);
        await onSuccess?.();
      },
    });
  }
}
